import { render } from "./InstitutionsManual.vue?vue&type=template&id=23a57549&scoped=true"
import script from "./InstitutionsManual.vue?vue&type=script&lang=js"
export * from "./InstitutionsManual.vue?vue&type=script&lang=js"

import "./InstitutionsManual.vue?vue&type=style&index=0&id=23a57549&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a57549"]])

export default __exports__